import Router from "@services/router";
import CurrentPage from "./components/pages/Current";
import DetailsPage from "./components/pages/Details";
import GalleryPage from "./components/pages/Gallery";
import ParticipatingPage from "./components/pages/Participating";
import PastPage from "./components/pages/Past";
import SalonPage from "./components/pages/Salon";
import SettingsPage from "./components/pages/Settings";
import withDetails from "./middleware/withDetails";
import withoutDetails from "./middleware/withoutDetails";
import ProfilePage from './components/pages/Profile'

export default [
    Router.group({ middleware: withDetails() }, [
        Router.page({ name: ["customer", "customer:profile", "app"], path: "/app", component: ProfilePage }),
        Router.page({ name: "customer:current", path: "/app/open", component: CurrentPage }),
        Router.page({ name: "customer:participating", path: "/app/entries", component: ParticipatingPage }),
        Router.page({ name: "customer:past", path: "/app/results", component: PastPage }),
        Router.page({ name: "customer:gallery", path: "/app/gallery", component: GalleryPage }),
        Router.page({ name: "customer:settings", path: "/app/settings", component: SettingsPage }),
        Router.page({ name: "customer:salon", path: "/app/salons/:id", component: SalonPage }),
    ]),

    Router.group({ middleware: withoutDetails() }, [
        Router.page({ name: "customer:details", path: "/app/details", component: DetailsPage })
    ])
]